let meTmp:any;

if (typeof window !== 'undefined') {
    meTmp = window;
} else {
    meTmp = {};
}

export const me = meTmp;
export const top = me.top || me.parent;
